import 'moment/locale/de';
import moment from 'moment';
import type { GQLLanguage } from 'codegen/gql-types';
import OverlayPortalTarget from 'layouts/OverlayPortalTarget';
import TooltipPortalTarget from 'layouts/TooltipPortalTarget';
import { authNS, StoreState } from 'components/auth/store/Store';
import GlobalSnackbarContainer from 'components/snackbar/GlobalSnackbarContainer';
import { Component, Watch } from 'vue-property-decorator';
import { Component as TsxComponent } from 'vue-tsx-support';
import InputDropdownPortalTarget from 'layouts/InputDropdownPortalTarget';
import styles from './styles';
import VueTimeZoneProvider from './services/vue-time-zone-provider/VueTimeZoneProvider';
import Loader from './components/loader/Loader';

@Component
class Root extends TsxComponent<{}> {
  @authNS.State
  protected currentEmployment: StoreState['currentEmployment'];

  @authNS.State
  protected currentCompany: StoreState['currentCompany'];

  @Watch('currentEmployment.language')
  protected onLanguageChange(language?: GQLLanguage) {
    // this is needed for calendar
    moment.locale(language?.locale || 'en', {
      week: {
        dow: 1,
      },
    });
    this.$i18n.i18next.changeLanguage(language?.locale || 'en');
  }

  @Watch('currentCompany.timeZone')
  protected onTimeZoneChange(timeZone?: string) {
    if (timeZone) {
      VueTimeZoneProvider.setTimeZone(timeZone);
    }
  }

  private get isAuthDataLoaded() {
    return this.currentCompany && this.currentEmployment;
  }

  public created() {
    // init moment locale
    moment.locale(this.$i18n.i18next.language || 'en', {
      week: {
        dow: 1,
      },
    });
  }

  public render() {
    return (
      <div class={styles.root}>
        {/* TODO: Add proper loading screen */}
        {this.isAuthDataLoaded ? <router-view /> : <Loader />}
        <InputDropdownPortalTarget />
        <OverlayPortalTarget />
        <TooltipPortalTarget />
        <GlobalSnackbarContainer />
      </div>
    );
  }
}

export default Root;
